import { render, staticRenderFns } from "./AddEditReminder.vue?vue&type=template&id=0d1f1738&scoped=true"
import script from "./AddEditReminder.vue?vue&type=script&lang=js"
export * from "./AddEditReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f1738",
  null
  
)

export default component.exports